import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import ColorSwatchButton from 'components/ColorSwatchButton';
import { Small, Medium, LargeUp } from 'components/MediaQuery';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import DesktopSwatchListPlaceholder from './DesktopSwatchListPlaceholder';
import MobileSwatchListPlaceholder from './MobileSwatchListPlaceholder';

const SWATCH_SIZE_MOBILE = 30;
const SWATCH_SIZE_DESKTOP = 40;

class SwatchList extends React.Component {
  renderSwatchButton = ({ diameter, handle, swatchImageUrl, colors, colorName }) => {
    const { onSelect, currentProductHandle, swatchAngle } = this.props;

    return (
      <ColorSwatchButton
        className="SwatchList__item"
        imageUrl={swatchImageUrl}
        colors={colors}
        onClick={() => onSelect(handle)}
        key={handle}
        ariaLabel={I18n.localize('pdp.productSelector.selectColor', {
          colorName,
        })}
        isSelected={handle === currentProductHandle}
        diameter={diameter}
        angle={swatchAngle}
      />
    );
  };

  render() {
    const { products, isLoading } = this.props;

    return (
      <>
        {isLoading ? (
          <>
            <Small>
              <MobileSwatchListPlaceholder />
            </Small>
            <Medium>
              <MobileSwatchListPlaceholder />
            </Medium>
            <LargeUp>
              <DesktopSwatchListPlaceholder />
            </LargeUp>
          </>
        ) : (
          <div className="SwatchList">
            {map(products, ({ handle, swatchImageUrl, colors, colorName }) => (
              <React.Fragment key={handle}>
                <Small>
                  {this.renderSwatchButton({
                    handle,
                    swatchImageUrl,
                    colors,
                    colorName,
                    diameter: SWATCH_SIZE_MOBILE,
                  })}
                </Small>
                <Medium>
                  {this.renderSwatchButton({
                    handle,
                    swatchImageUrl,
                    colors,
                    colorName,
                    diameter: SWATCH_SIZE_MOBILE,
                  })}
                </Medium>
                <LargeUp>
                  {this.renderSwatchButton({
                    handle,
                    swatchImageUrl,
                    colors,
                    colorName,
                    diameter: SWATCH_SIZE_DESKTOP,
                  })}
                </LargeUp>
              </React.Fragment>
            ))}
          </div>
        )}
        <style jsx>
          {`
            .SwatchList {
              display: flex;
              flex-wrap: wrap;
              justify-content: left;
              gap: ${Theme.get('spacing-px')};
              margin-left: ${Theme.get('spacing') * -1.25}px;
            }

            @media ${largeUp} {
              .SwatchList {
                justify-content: flex-start;
                margin-bottom: 0px;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .SwatchList__item {
              margin: ${Theme.get('touch-target-spacing') / 2}px;
              flex-shrink: 0;
            }

            @media ${largeUp} {
              .SwatchList__item {
                margin: ${Theme.get('spacing')}px;
              }
            }
          `}
        </style>
      </>
    );
  }
}

SwatchList.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      colorName: PropTypes.string.isRequired,
      colors: PropTypes.arrayOf(PropTypes.string),
      handle: PropTypes.string.isRequired,
      swatchImageUrl: PropTypes.string,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  currentProductHandle: PropTypes.string,
  swatchAngle: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
};

SwatchList.defaultProps = {
  currentProductHandle: null,
  swatchAngle: 135,
};

export default SwatchList;
